import React from 'react';
import {Switch, Tooltip, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import {FormikTextField} from '@src/components/FormikFields';
import {InfoCard} from '@src/modules/accountDashboard/components/InfoCard';
import {AssessmentInfoCard as DataAssessmentInforCard} from '@src/screens/AccountEdit/components/AssessmentInfoCard';

import {handleOnWheel, numberFilter} from '../../utils';
import {AssessmentInfoCard} from '../AssessmentInfoCard';

import styles from './assessmentResources.module.scss';

export default function AssessmentResources({formik, totalCredits, isCreate}){
    const {t} = useTranslation();

    const assessmentKey = 'assessment';
    const assessmentLabel = 'ACCOUNTS_PAGE.ASSESSMENT_CHECK';
    const assessmentDisabled = !formik.values?.business_name || !formik.values?.cnpj;
    const isEnabled = !!formik?.values?.modules?.[assessmentKey];
    const toggleLabel = (!assessmentDisabled && isEnabled) ? t('ACCOUNTS_PAGE.ENABLED') : t('ACCOUNTS_PAGE.DISABLED');

    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <Typography variant='h6' component='h6' mt={3} mb={1}>
                    {t(assessmentLabel)}
                </Typography>
            </div>
            <AssessmentInfoCard />
            {assessmentDisabled && <DataAssessmentInforCard />}
            <div className={styles.row}>
                <div className={`${styles.item} ${styles.itemCenter} ${typeof totalCredits !== 'number' ? styles.fullItem : ''}`}>
                    <Tooltip title={toggleLabel}>
                        <Switch
                            disabled={assessmentDisabled}
                            onChange={() => formik.setFieldValue(`modules.${assessmentKey}`, !formik.values?.modules[assessmentKey])}
                            name={`modules.${assessmentKey}`}
                            checked={!assessmentDisabled && isEnabled}
                            formik={formik}
                        />
                    </Tooltip>
                    <div>
                        {toggleLabel}
                    </div>
                </div>

                {typeof totalCredits === 'number' && <div className={styles.item}>
                    <InfoCard
                        className={'styles.itemValue'}
                        iconName={'Coin'}
                        name={t('ACCOUNTS_PAGE.TOTAL_CREDITS')}
                        total={totalCredits}
                    />
                </div>
                }

            </div>

            <Typography variant='h6' component='h6' mt={3} mb={1}>
                {t('ACCOUNTS_PAGE.GENERAL_INFO')}
            </Typography>
            <div className={styles.column}>
                <FormikTextField
                    className={styles.inputQuantity}
                    name='assessment.quantity'
                    data-qa='account-assessment-quantity'
                    label={t('ACCOUNTS_PAGE.ASSESSMENT_ANNUAL_CREDIT')}
                    formik={formik}
                    type='number'
                    fullWidth
                    onKeyPress={(e) => numberFilter(e)}
                    onWheel={handleOnWheel}
                    value={formik?.values?.assessment?.quantity}
                    onChange={(e) => formik.setFieldValue('assessment.quantity', e.target.value)}
                    error={Boolean(formik.touched.assessment?.quantity && formik.errors.assessment?.quantity)}
                    helperText={formik.touched.assessment?.quantity && formik.errors.assessment?.quantity}
                />
                {!isCreate && <FormikTextField
                    className={styles.inputQuantity}
                    name='assessment.quantity'
                    data-qa='account-assessment-quantity'
                    label={t('ACCOUNTS_PAGE.CREDIT_RENEWAL_DATE')}
                    formik={formik}
                    fullWidth
                    onKeyPress={(e) => numberFilter(e)}
                    onWheel={handleOnWheel}
                    value={formik?.values?.assessment?.birthdate ? moment(formik.values.assessment.birthdate).format('DD/MM') : ''}
                    disabled
                    error={Boolean(formik.touched.assessment?.birthdate && formik.errors.assessment?.birthdate)}
                    helperText={formik.touched.assessment?.birthdate && formik.errors.assessment?.birthdate}
                />}
            </div>
        </div>
    );
}
